module.exports = __webpack_public_path__ + "img/plus.2a7fc4a1.svg";